export enum FieldType {
    Input = 'custom-input',
    Textarea = 'textarea',
    Checkbox = 'checkbox',
    MultiCheckbox = 'multicheckbox',
    Select = 'custom-select',
    Numeric = 'numeric-input',
    ColorPicker = 'color-picker',
    DatePicker = 'datepicker',
    TimePicker = 'timepicker',
    DateTimePicker = 'datetimepicker',
    Combobox = 'combobox',
    CustomCombobox = 'custom-combobox',
    Radio = 'radio',
    Separator = 'separator',
    Html = 'html',
    InputGroup = 'input-group',
    ButtonRadio = 'button-radio',
    Button = 'button',
    Template = 'template',
    FileSelect = 'file-select',
    RepeatSection = 'repeat-section',
    ButtonCheckboxGroup = 'button-checkbox-group',
    SectionHeader = 'section-header',
    PhoneInput = 'phone-input',
    ImageUpload = 'image-upload',
    PasswordIndicator = 'password-indicator',
}